// admin-auth.guard.ts
import { inject, Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, type CanActivate, type GuardResult, MaybeAsync, Router } from '@angular/router';
import { ApiService } from '@app/core/api.service';
import { SessionService } from '@app/core/session.service';


@Injectable({
  providedIn: 'root'
})
export class AdminActivateGuard implements CanActivate {
  api = inject(ApiService);
  router = inject(Router);
  sessionService = inject(SessionService);
  async canActivate(
    route: ActivatedRouteSnapshot,
  ): Promise<GuardResult> {
    // const res = await this.api.aget<{
    //   is_admin: boolean;
    // }>('sessions/admin-guard');
    // if (!res || !res.is_admin) {
    //   alert('You are not authorized to access this page');
    //   this.router.navigate(['/']);
    //   return false;
    // }
    // console.log('AdminActivateGuard: User is admin, allowing access');
    // return true;
    await this.sessionService.ensureSessionDataLoaded();
    if (!this.sessionService.userIsAdmin()) {
      alert('You are not authorized to access this page');
      this.router.navigate(['/']);
      return false;
    }
    console.log('AdminActivateGuard: User is admin, allowing access');
    return true;
  }
}